import React, { ReactNode } from 'react'
import {
  Dimensions,
  Image,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  StyleSheet,
  View,
} from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { authImage, iconApp } from '@assets'
import { Screen } from './Screen'
import { Icon, Text } from '../atoms'
import { MIN_BIG_DEVICE_HEIGHT } from '@utils'

type ScreenAuthProps = {
  children: ReactNode
  title: string
  isPending?: boolean
  onPressBackIcon?: () => void
}

const heightAuthImage = 200
const heightIconApp = 110

const { height } = Dimensions.get('window')

export const ScreenAuth = ({
  children,
  title,
  isPending,
  onPressBackIcon,
}: ScreenAuthProps): React.ReactElement => {
  const theme = useTheme()
  const { top } = useSafeAreaInsets()

  const styles = getStyle(theme, top)

  const keyboardVerticalOffset =
    Platform.OS === 'ios' ? (height > MIN_BIG_DEVICE_HEIGHT ? 30 : 0) : 20

  return (
    <Screen noPaddingTop isPending={isPending} statusBarStyle="light" paddingBottom>
      <KeyboardAvoidingView
        style={{ flex: 1 }}
        behavior={Platform.OS === 'ios' ? 'padding' : undefined}
        keyboardVerticalOffset={keyboardVerticalOffset}
      >
        <ScrollView contentContainerStyle={{ flexGrow: 1 }}>
          <Image source={authImage} style={styles.authImage} />
          <Image source={iconApp} style={styles.iconApp} />

          <View style={styles.contentContainer}>
            <Text type="titleBold" color={theme.colors.primary}>
              {title}
            </Text>

            {children}
          </View>

          {onPressBackIcon && (
            <Icon
              name="arrowBack"
              containerStyle={styles.backIcon}
              color={theme.colors.white}
              onPress={onPressBackIcon}
            />
          )}
        </ScrollView>
      </KeyboardAvoidingView>
    </Screen>
  )
}

const getStyle = (theme: Theme, top: number) =>
  StyleSheet.create({
    contentContainer: {
      flex: 1,
      alignItems: 'center',
      paddingTop: heightAuthImage / 4 + theme.spacing.xl,
      paddingHorizontal: theme.spacing.xl,
    },
    authImage: {
      width: '100%',
      height: heightAuthImage + top,
    },
    iconApp: {
      position: 'absolute',
      top: heightAuthImage + top - heightAuthImage / 4,
      alignSelf: 'center',
      width: heightIconApp,
      height: heightIconApp,
    },
    backIcon: {
      position: 'absolute',
      left: '20%',
      marginLeft: -(heightIconApp / 2),
      top: heightAuthImage + top - heightAuthImage / 13,
      padding: theme.spacing.xxs,
      borderRadius: theme.border.jumbo,
      backgroundColor: theme.colors.primary,
      alignItems: 'center',
      justifyContent: 'center',
      width: theme.iconSize.jumbo,
      height: theme.iconSize.jumbo,
    },
  })
